const Nuls = {
  symbol: 'nuls',
  color: '#000',
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#82bd39" r="16"/><path d="M14.403 19.36L16 21.464V26l-6-2.663V11.619c0-.173.077-.338.212-.453l.683-.585a.636.636 0 01.923.097l5.465 7.164 3.019 1.846v-9.88l-2.668-1.331-.13 6.196-1.412-1.873-.064-6.8L22 8.779v11.664l-1.357 1.118-4.274-2.387-4.744-6.223-.065 9.454 2.825 1.447z" fill="#fff" fill-rule="nonzero"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-1.597-12.64l-.018 4.492-2.825-1.447.065-9.454 4.744 6.223 4.274 2.387L22 20.443V8.779L16.028 6l.064 6.8 1.413 1.873.129-6.196 2.668 1.331v9.88l-3.019-1.846-5.465-7.164a.636.636 0 00-.923-.098l-.683.586a.591.591 0 00-.212.453v11.718L16 26v-4.536z" fill-rule="evenodd"/>`;
  }
};
export default Nuls;
